import Vue from 'vue'
import App from './App.vue'


Vue.config.productionTip = false

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import './assets/css/index.less';
Vue.use(ViewUI);
import {Message} from 'view-design'
Vue.prototype.$Message = Message
import VueI18n from "vue-i18n";
import store from './store/index'
Vue.use(VueI18n);
import { i18n } from "./assets/lang";
// 移动端vant 2 ui框架
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

//工具函数
import Tools from './tool/index'
Vue.prototype.$Tools = Tools;

//接口们
import { Api,bsApi,coingnApi,hkshareApi,foxexApi } from './network/index'
// 请求方法 全局变量
Vue.prototype.$Api = Api;
Vue.prototype.$bsApi = bsApi;
Vue.prototype.$coingnApi = coingnApi;
Vue.prototype.$hkshareApi = hkshareApi;
Vue.prototype.$foxexApi = foxexApi;
// const serve = 'http://192.168.101.10/wooh'
// const serve = 'http://39.107.247.125/wooh'
// Vue.prototype.$serve = serve;
// 上传图片路径
// Vue.prototype.$imageUrl = serve + "/LayUiUploadController/uploadFtpFile.json";
// if (process.env.NODE_ENV === 'development') {
  // const vConsoleScript = document.createElement('script')
  // vConsoleScript.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js'
  // vConsoleScript.onload = () => {
  //   const vConsole = new window.VConsole()
  //   console.log('[vConsole] 调试工具已加载')
  // }
  // document.head.appendChild(vConsoleScript)
// }
import router from './router'
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
